import React, { Component } from 'react';
import './global.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as queryString from 'query-string';
import { bindActionCreators } from 'redux';
import * as authAction from '../../actions/authAction';
import AppBar from '../../component/appBar/appBar';
import * as menuAction from '../../actions/menuAction';
import { MenuSession } from '../../services/constants';
import { getStorage } from '../../services/utils';
import * as R from 'ramda';
import * as globalAction from '../../actions/globalAction';
import PropTypes from 'prop-types';

export class GlobalPage extends Component {
  static propTypes = {
    menu: PropTypes.shape({
      menuList: PropTypes.shape({
        merchant: PropTypes.shape({
          id: PropTypes.number,
        }),
        code: PropTypes.string,
      }),
    }),
    checkout: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.any),
    }),
    user: PropTypes.any,
    global: PropTypes.shape({
      query: PropTypes.object,
    }),
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired,
      push: PropTypes.func.isRequired,
      replace: PropTypes.func.isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }),
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }),
    menuAction: PropTypes.shape({
      getMenu: PropTypes.func.isRequired,
    }),
    authAction: PropTypes.shape({
      getUserAccount: PropTypes.func.isRequired,
    }),
    globalAction: PropTypes.shape({
      saveParsedQuery: PropTypes.func.isRequired,
    }),
  };

  constructor() {
    super();
    this.state = {
      currentRoute: '',
    };

    this.footerList = [
      { icon: 'utensils', url: '/menu', name: 'Menu', subUrl: ['/checkout'] },
      { icon: 'wallet', url: '/cashback-history', name: 'My Cashback' },
      { icon: 'file-alt', url: '/history', name: 'History' },
      { icon: 'info', url: '/about', name: 'About' },
    ];
  }

  getMenu = (merchantId, dinningMethod) => {
    if (
      !this.props.menu.menuList ||
      (merchantId &&
        this.props.menu.menuList.merchant.id !== Number(merchantId))
    ) {
      this.props.menuAction.getMenu(merchantId, dinningMethod);
    }
  };

  componentDidMount() {
    // when route change
    this.unlisten = this.props.history.listen(history => {
      this.setCurrentRoute(history.pathname);
    });

    this.setCurrentRoute(this.props.history.location.pathname);

    if (R.not(R.isEmpty(getStorage('apiKey'))) && R.isEmpty(this.props.user)) {
      this.props.authAction.getUserAccount();
    }

    let { ...parsedQuery } = queryString.parse(this.props.location.search);

    if (parsedQuery.merchantId) {
      let query = JSON.parse(getStorage('query'));
      if (query.pickUpType) {
        parsedQuery['pickUpType'] = query.pickUpType;
      }

      sessionStorage.setItem(
        MenuSession.savedParsedQuery,
        queryString.stringify(parsedQuery),
      );
      this.props.globalAction.saveParsedQuery(parsedQuery);
    } else {
      let savedParsedQuery = sessionStorage.getItem(
        MenuSession.savedParsedQuery,
      );
      if (savedParsedQuery) {
        this.props.globalAction.saveParsedQuery(
          queryString.parse(savedParsedQuery),
        );
      }
    }

    const merchantId =
      parsedQuery.merchantId ||
      R.path(['global', 'query', 'merchantId'])(this.props);

    if (merchantId) {
      sessionStorage.setItem(MenuSession.merchantId, merchantId);
      let dinningMethod;
      if (parsedQuery) {
        if (parsedQuery.delivery === '1') {
          dinningMethod = 'DELIVERY';
        } else if (parsedQuery.takeAway === '1') {
          if (parsedQuery.tableNo) {
            dinningMethod = 'DINE_IN';
          } else {
            dinningMethod = 'PICKUP';
          }
        } else {
          dinningMethod = 'DINE_IN';
        }
      }

      sessionStorage.setItem(MenuSession.dinningMethod, dinningMethod);

      this.getMenu(merchantId, dinningMethod);
    } else {
      let merchantId = sessionStorage.getItem(MenuSession.merchantId);
      let dinningMethod = sessionStorage.getItem(MenuSession.dinningMethod);
      if (merchantId && dinningMethod) {
        this.getMenu(merchantId, dinningMethod);
      }
    }
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.menu.menuList) {
      if (
        this.props.menu.menuList.code === '500' &&
        this.state.currentRoute.includes('/menu')
      ) {
        setTimeout(() => {
          this.props.history.replace('/cashback-history');
        }, 500);
      }
    }
  }
  setCurrentRoute = pathname => {
    this.setState({
      currentRoute: pathname,
    });
  };

  renderFooter = () => {
    const isActive = type => {
      const urlList = [...[], type.url].concat(type.subUrl || []);
      return urlList.includes(this.state.currentRoute) ? 'active' : '';
    };

    const goTo = url => () => {
      this.props.history.push(
        url === '/menu'
          ? `/menu?${queryString.stringify(this.props.global.query)}`
          : url,
      );
    };

    return (
      <div className='footer'>
        {this.footerList.map(footer =>
          footer.name !== 'Menu' ||
          (this.props.menu.menuList &&
            this.props.menu.menuList.code !== '500' &&
            footer.name === 'Menu') ? (
            <div
              key={footer.name}
              className={'icon-container ' + isActive(footer)}
              onClick={goTo(footer.url)}
            >
              {footer.name === 'Checkout' &&
                !!this.props.checkout.items.length && (
                  <div className='cart-no'>
                    <span>{this.props.checkout.items.length}</span>
                  </div>
                )}
              {footer.name === 'About' ? (
                this.alimentLogo()
              ) : (
                <FontAwesomeIcon icon={footer.icon} />
              )}
              <div>{footer.name}</div>
            </div>
          ) : (
            <div key={footer.name} />
          ),
        )}
      </div>
    );
  };

  alimentLogo = () => {
    // fill currentColor is use to correspond to css color

    //customize sendiri jekkk
    return (
      <svg
        className={'aliments-logo'}
        viewBox='0 0 6000 6000'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          className='st1'
          fill='currentColor'
          d='M 4445.834 3989.933 L 3451.587 3989.933 L 3451.587 4984.18 C 3451.587 5533.289 3896.818 5978.427 4445.834 5978.427 C 4538.214 5978.427 4627.273 5964.829 4712.133 5941.268 C 4721.846 5938.573 4731.903 5936.678 4741.475 5933.717 C 4801.458 5915.044 4858.872 5890.605 4913.42 5861.467 C 4915.456 5860.371 4917.65 5859.525 4919.733 5858.428 C 4975.832 5827.927 5028.656 5792.179 5077.564 5751.887 C 5077.783 5751.714 5078.002 5751.573 5078.222 5751.401 C 5095.391 5737.239 5111.417 5721.793 5127.615 5706.519 C 5134.539 5699.94 5142.09 5693.987 5148.842 5687.188 C 5155.641 5680.436 5161.594 5672.885 5168.173 5665.961 C 5183.447 5649.763 5198.894 5633.737 5213.055 5616.568 C 5213.228 5616.348 5213.369 5616.129 5213.541 5615.91 C 5253.833 5567.002 5289.582 5514.177 5320.083 5458.079 C 5349.174 5404.503 5373.126 5347.746 5392.113 5288.781 C 5393.084 5285.742 5394.447 5282.875 5395.371 5279.82 C 5398.332 5270.249 5400.228 5260.176 5402.922 5250.479 C 5426.483 5165.603 5440.081 5076.544 5440.081 4984.18 C 5440.081 4435.164 4994.944 3989.933 4445.834 3989.933 Z M 1485.667 2001.439 L 2479.914 2001.439 L 2479.914 1007.192 C 2479.914 458.082 2034.683 12.945 1485.667 12.945 C 1393.287 12.945 1304.228 26.542 1219.368 50.103 C 1209.655 52.798 1199.598 54.693 1190.026 57.654 C 1130.043 76.328 1072.628 100.766 1018.081 129.904 C 1016.044 131 1013.851 131.846 1011.768 132.943 C 955.669 163.444 902.845 199.193 853.937 239.485 C 853.718 239.657 853.498 239.798 853.279 239.97 C 836.11 254.132 820.084 269.578 803.886 284.852 C 796.961 291.432 789.411 297.384 782.659 304.183 C 775.86 310.935 769.907 318.486 763.327 325.41 C 748.053 341.608 732.607 357.634 718.445 374.804 C 718.273 375.023 718.132 375.242 717.96 375.462 C 677.668 424.37 641.919 477.194 611.418 533.292 C 582.327 586.869 558.375 643.625 539.388 702.59 C 538.417 705.629 537.054 708.512 536.13 711.551 C 533.169 721.123 531.273 731.196 528.579 740.893 C 505.018 825.769 491.42 914.827 491.42 1007.192 C 491.42 1556.207 936.557 2001.439 1485.667 2001.439 Z M 4445.834 12.929 C 3896.802 12.929 3451.587 458.066 3451.587 1007.176 L 3451.587 2001.423 L 2479.93 2001.423 L 2479.93 1007.176 C 2479.93 458.066 2034.698 12.929 1485.683 12.929 C 936.667 12.929 491.436 458.066 491.436 1007.176 L 491.436 4984.18 C 491.436 5533.289 936.667 5978.427 1485.683 5978.427 C 2034.698 5978.427 2479.93 5533.289 2479.93 4984.18 L 2479.93 3989.933 L 3451.587 3989.933 L 3451.587 4984.18 C 3451.587 5533.289 3896.818 5978.427 4445.834 5978.427 C 4994.85 5978.427 5440.081 5533.289 5440.081 4984.18 L 5440.081 1007.192 C 5440.081 458.066 4994.85 12.929 4445.834 12.929 Z'
        />
      </svg>
    );
  };

  render() {
    const isCheckoutPage =
      this.props.location.pathname.includes('checkout') ||
      this.props.location.pathname.includes('addresslist');
    const haveNoMenuParam = this.props.location.search.includes('noMenu');
    const isShowGlobalPage = !isCheckoutPage && !haveNoMenuParam;
    const chain = sessionStorage.getItem('chain');
    const tableNo = sessionStorage.getItem('tableNo');

    return (
      <div className='global-page'>
        {tableNo && (
          <AppBar
            goBack={() =>
              this.props.history.push(
                chain
                  ? `/outlet?chain=${chain}&tableNo=${tableNo}`
                  : `/outlet?tableNo=${tableNo}`,
              )
            }
          >
            <div>Go Back To Home</div>
          </AppBar>
        )}
        {isShowGlobalPage && this.renderFooter()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkout: state.Checkout,
    user: state.Auth.user,
    menu: state.Menu,
    global: state.Global,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    authAction: bindActionCreators(authAction, dispatch),
    menuAction: bindActionCreators(menuAction, dispatch),
    globalAction: bindActionCreators(globalAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalPage);
